import api from '../api'

export async function getYears() {
  return api.get('util/year');
}
